// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OEmbed_wrapper__wyM6z"};